<template>
  <oxd-input-group :label="label" class="oxd-input-field-bottom-space">
    <div
      class="payslip-readonly-field__value"
      :class="{
        'payslip-readonly-field__value--capitalize': capitalize,
      }"
    >
      {{ displayValue }}
    </div>
    <oxd-text v-if="hint" class="orangehrm-input-hint" tag="p">
      {{ hint }}
    </oxd-text>
  </oxd-input-group>
</template>

<script>
export default {
  name: 'PayslipReadonlyField',
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number],
      default: '',
    },
    hint: {
      type: String,
      default: '',
    },
    capitalize: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayValue() {
      if (this.value === null || this.value === undefined) {
        return '';
      }
      return String(this.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.payslip-readonly-field__value {
  box-sizing: border-box;
  width: 100%;
  min-height: 45px;
  padding: 0.675rem 0.5rem;
  border: 1px solid $oxd-interface-gray-lighten-2-color;
  border-radius: 0.65rem;
  background-color: #f0f0fc;
  color: $oxd-interface-gray-darken-1-color;
  font-family: Nunito Sans, sans-serif;
  font-size: $oxd-input-control-font-size;
  font-weight: 400;
  line-height: 1.5;
  display: flex;
  align-items: center;

  &--capitalize {
    text-transform: capitalize;
  }
}
</style>
